import { useEffect, useState } from 'react'
import AnimatedLetters from '../AnimatedLatters'
import './index.scss'
import logo from '../../assets/Images/myPic-2.png'
import { useNavigate } from 'react-router-dom'
import Loader from 'react-loaders'

export default function Home(){
    const [letterClass,setLetterClass]=useState('text-animate')
    const navigate=useNavigate()

    useEffect(()=>{
        setTimeout(()=>{
            setLetterClass('text-animate-hover')
        },3000)
    },[])
    return(
        <>
            <div className='home-page'>
                <div className='text-zone'>
                    <div className='heading'>
                        <h1>

                            <span className={`${letterClass} _10`}>H</span>
                            <span className={`${letterClass} _11`}>i,</span> <br />
                            <span className={`${letterClass} _12`}>I'</span>
                            <span className={`${letterClass} _13`}>am</span><br />
                            <AnimatedLetters strAry={[...'Mohammed '.split('')]} idx={14} letterClass={letterClass} /> 
                            <AnimatedLetters strAry={'Aslam'.split('')} letterClass={letterClass} idx={15} />
                            <br />
                            <AnimatedLetters strAry={[...'Web '.split('')]} idx={16} letterClass={letterClass}/>
                            <AnimatedLetters strAry={[...'Developer'.split('')]} letterClass={letterClass} idx={17} />
                        </h1>
                    </div>
                    <p className=' text-left'>FullStack Developer/ Mern Developer</p>
                    <button onClick={()=>navigate('/contact')} className='btn'>Contact me</button>
                </div>
                <div className='logo-con'>
                    <img className='logo' src={logo} alt="mypicture" />
                </div>
            </div>
            <Loader type='pacman' />
        </>
    )
}